class MyWUCountryDropdown {
    constructor(elem) {
        this.inputField = elem.querySelector('.wu-input input');
        this.countryList = elem.querySelectorAll('.wuds-dropdown__items');
        this.countryDropdown = elem.querySelector('.wuds-dropdown');
        this.learnMoreButton = document.getElementById("learnMoreButton");
        this.searchInput = elem.querySelector('.wuds-dropdown__search__box');
        this.clearButton = elem.querySelector('.wuds-dropdown__search__cancel__icon');       
        this.init();
    }
    init() {
        this.listeners();
        this.countryDropdown.style.display = 'none';
    }
    listeners() {
        document.addEventListener('click', e => {
            if (e.target.closest('.mywuCountryDrop') || e.target === this.inputField) {
                this.toggleDropdown();
            } else if (!e.target.closest('.wuds-dropdown')) {
                this.closeDropdown();
            }
        });
        this.countryList.forEach(item => {
            item.addEventListener('click', () => {
                this.updateInputField(item);
                this.updateLearnMoreLink(item);
                this.closeDropdown();
            });
        });
        if (this.searchInput) {
            this.searchInput.addEventListener('input', () => this.searchFilter());
        }      
        if (this.clearButton) {
            this.clearButton.addEventListener('click', () => this.clearSearch());
        }
    }
    toggleDropdown() {
        this.countryDropdown.style.display = this.countryDropdown.style.display === 'none' ? 'block' : 'none';
    }
    closeDropdown() {
        this.countryDropdown.style.display = 'none';
    }
    updateInputField(item) {
        const countryName = item.textContent.trim();
        this.inputField.value = countryName;
    }
    updateLearnMoreLink(item) {
        const countryUrl = item.getAttribute('data-url');
        this.learnMoreButton.setAttribute('href', countryUrl);
    }    
    searchFilter() {
        const filterText = this.searchInput.value.toUpperCase();
        this.clearButton.style.display = filterText.length > 0 ? 'flex' : 'none';

        this.countryList.forEach(item => {
            const countryName = item.textContent.toUpperCase();
            item.style.display = countryName.indexOf(filterText) > -1 ? 'block' : 'none';
        });
    }   
    clearSearch() {
        this.searchInput.value = '';
        this.searchFilter();
        this.searchInput.focus();
    }
}

const mywuDropdownCountry = document.querySelectorAll('.mywuCountryListdrop');
if (mywuDropdownCountry.length > 0) {
    for (
            let i=0; 
            i<mywuDropdownCountry.length; 
            i++
        ) {
            new MyWUCountryDropdown(mywuDropdownCountry[i])
        }
 }